import axios from 'axios';
import store from '@/store';

// 后端 /api/logs 未就绪时设为 false，避免每次路由跳转都触发 404
const LOG_ENABLED = false;

export function logAction({ action, targetType = null, targetId = null, description = null, extra = {} }) {
    if (!LOG_ENABLED) return;

    const user = store.getters.currentUser || { userId: 'guest' };
    const payload = {
        user_id: user.userId || 'guest',
        action,
        target_type: targetType,
        target_id: targetId,
        description,
        extra,
        timestamp: new Date().toISOString()
    };

    axios.post('/api/logs', payload).catch(() => {
        // 静默降级，不打日志避免递归
    });
}